module.exports = __webpack_public_path__ + "static/media/tn.76fc605f.svg";